// extracted by mini-css-extract-plugin
module.exports = {"TableBanner__text":"TableBanner__text__2cnLc"};